export const paramMapToStrDetailed = (paramMap?: Record<string, any>) => {
  let str = '';

  if (!paramMap) return str;

  for (const k in paramMap) {
    const v = paramMap[k];

    if (Array.isArray(v)) {
      v.forEach(i => str += `&${k}=${i}`)
    } else {
      str += `&${k}=${v}`
    }
  }

  return str.slice(1);
};